module.exports = __webpack_public_path__ + "img/form-2@2x.1e49c3d.webp";